import React, { FC } from "react";
import { ISvG } from "~/types/SvGTypes";

const CheckInCircleIcon: FC<ISvG> = ({ fill = "#ffffff" }) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8738 6.70711C14.2643 6.31658 14.2643 5.68342 13.8738 5.29289C13.4832 4.90237 12.8501 4.90237 12.4596 5.29289L13.8738 6.70711ZM7.33332 11.8334L6.62621 12.5405C7.01674 12.931 7.6499 12.931 8.04042 12.5405L7.33332 11.8334ZM5.54039 8.62622C5.14986 8.2357 4.5167 8.2357 4.12617 8.62623C3.73565 9.01675 3.73565 9.64992 4.12618 10.0404L5.54039 8.62622ZM13.1667 6L12.4596 5.29289L6.62621 11.1262L7.33332 11.8334L8.04042 12.5405L13.8738 6.70711L13.1667 6ZM4.83328 9.33333L4.12618 10.0404L6.62621 12.5405L7.33332 11.8334L8.04042 11.1262L5.54039 8.62622L4.83328 9.33333ZM16.5 8.5H15.5C15.5 12.0899 12.5899 15 9 15V16V17C13.6944 17 17.5 13.1944 17.5 8.5H16.5ZM9 16V15C5.41015 15 2.5 12.0899 2.5 8.5H1.5H0.5C0.5 13.1944 4.30558 17 9 17V16ZM1.5 8.5H2.5C2.5 4.91015 5.41015 2 9 2V1V0C4.30558 0 0.5 3.80558 0.5 8.5H1.5ZM9 1V2C12.5899 2 15.5 4.91015 15.5 8.5H16.5H17.5C17.5 3.80558 13.6944 0 9 0V1Z"
        fill={fill}
      />
    </svg>
  );
};

export default CheckInCircleIcon;
